import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar as CalendarIcon } from "lucide-react";
import { DateTime } from "luxon";
import { BaseQuestionProps } from "../../index";
import { useState } from "react";

interface DatePickerProps extends BaseQuestionProps {
  storedValue?: Date | string;
  className?: string;
}

export const DatePicker: React.FC<DatePickerProps> = ({ field, disabled, placeholder, storedValue, className }) => {
  const [open, setOpen] = useState(false);

  const onDateSelect = (date: Date | undefined) => {
    if (!date) return;
    field.onChange(date);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={`w-[160px] justify-start text-left font-normal ${disabled ? "cursor-not-allowed border-slate-400 bg-slate-200" : "border-slate-400"} ${className}`}
          disabled={disabled}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {field.value ? (
            <span className="font-extralight">{DateTime.fromJSDate(new Date(field.value)).toFormat("MM/dd/yyyy")}</span>
          ) : (
            <span className="text-muted-foreground">{placeholder || "Pick a date"}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={field.value || new Date(storedValue as Date)}
          onSelect={onDateSelect}
          captionLayout="dropdown"
          endMonth={new Date(new Date().getFullYear() + 4, 11)}
          required={false}
        />
      </PopoverContent>
    </Popover>
  );
};
